import React from "react";
import { TitleRootProps } from "./Title.types";
import { Root as StyledRoot } from "./Root.styles";

/**
 * Main grouping component for Title. Typography.Title can be used directly as a child,
 * can also have an optional set of actions.
 */
export const Root = ({ children, className, breakpoint }: TitleRootProps) => (
  <StyledRoot className={className} breakpoint={breakpoint}>
    {children}
  </StyledRoot>
);
